import { render, staticRenderFns } from "./mergeStudent.vue?vue&type=template&id=428d5c26&"
import script from "./mergeStudent.vue?vue&type=script&lang=js&"
export * from "./mergeStudent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports